import React, {Component} from 'react';
import {Link} from 'react-router';

class Footer extends Component {
  render() {
    return (
      <footer className="row">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-8">
              <section className="section section-address" id="footer-address">
                <address className="address">
                  <h4 className="section-name">C&A Assembly & Installation Solution</h4>
                  <div className="wrapper">
                    <p>ABN 546 075 239 46</p>
                    <p>License No: 318791C</p>
                    <a href="https://www.google.com/maps/place/CNA+Assembly+%26Installation+Solution/@-33.9672153,151.1038652,18z/data=!3m1!4b1!4m5!3m4!1s0x6b12b92f54df748f:0xae0856e45b9c06b3!8m2!3d-33.9672153!4d151.1049595" aria-label="Google Maps - Opens in a new window" target="_blank" rel="noopener noreferrer" className="contact-tile">
                      <i className="fa fa-map"></i>
                      <div className="wrapper">
                        <span className="itemprop">Suite 406, 208 Forest Road, <br/>Hurstville, 2220</span>
                      </div>
                    </a>
                    <a href="tel:1800841999" className="contact-tile">
                      <i className="fa fa-phone"></i>
                      <div className="wrapper">
                        <span className="itemprop">1800841999</span>
                      </div>
                    </a>
                  </div>
                </address>
              </section>
            </div>
            <div className="col-xs-12 col-sm-4 section-social">
              <section id="footer-social-media">
                <h4 className="section-name">Social Media</h4>
                <ul className="list-unstyled social-media-links">
                  <li>
                    <a href="//www.instagram.com/cna.net.au/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram - Opens in a new window">
                    <img data-src="https://res.cloudinary.com/cna-net-au/image/upload/c_scale,w_50/v1537795854/misc/instagram-logo.png" alt="Follow us on Instagram" className="img-responsive logo lazyload"/>
                    </a>
                  </li>
                  <li>
                    <a href="//facebook.com/cna.net.au" target="_blank" rel="noopener noreferrer" aria-label="Find us on Facebook - Opens in a new window">
                    <img data-src="https://res.cloudinary.com/cna-net-au/image/upload/c_scale,w_50/v1537795854/misc/fb-logo.png" alt="Find us on Facebook" className="img-responsive logo lazyload"/>
                    </a>
                  </li>
                  <li>
                    <a href="https://pin.it/7eeqpi26sivuap" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Pinterest - Opens in a new window">
                    <img data-src="https://res.cloudinary.com/cna-net-au/image/upload/c_scale,w_50/v1537795854/misc/pinterest-logo.png" alt="Follow Us on Pinterest" className="img-responsive logo lazyload"/>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/c-a-assembly-and-installation-solution/" target="_blank" rel="noopener noreferrer" aria-label="Find us on Linked In - Opens in a new window">
                    <img data-src="https://res.cloudinary.com/cna-net-au/image/upload/c_crop,g_west,h_101,w_101/c_scale,h_50,w_50/v1537796007/misc/linkedIn-logo.png" alt="Find us on Linked In" className="img-responsive logo lazyload"/>
                    </a>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
        <div className="container common-footer-wrapper">
          <div className="row">
            <div className="col-xs-12 col-sm-8 pull-right policy"><Link to='/privacy-policy'>Privacy Policy</Link></div>
            <div className="col-xs-12 col-sm-4 pull-left">&copy; { new Date().getFullYear() } All rights reserved.</div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js